import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { TipoCodice } from '@app/shared/models/assistenza';
import { UtilityService } from '@app/shared/services/utility.service';
import { TranslateService } from '@ngx-translate/core';

// Tipo del codice associato all'assistenza: nessuno, RMPP o violazione (stessa gestione degli RMPP)
@Component({
  selector: 'ser-tipo-codice-select',
  templateUrl: './tipo-codice-select.component.html'
})
export class TipoCodiceSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() label: string = "assistenze.fields.tipoCodice";
  @Input() readonly: boolean = false;
  @Input() multiple: boolean = false;

  items: IS1InputSelectItem[];

  constructor(private utils: UtilityService, private translateService: TranslateService) {

    this.loadItems();

    this.translateService.onLangChange.subscribe(() => {
      this.loadItems();
    })

  }

  private loadItems() {
    this.items = this.utils.getInputSelectFromEnum(TipoCodice, 'assistenze.tipoCodice');
  }

}
